__turbopack_context__.v({
  "button": "button-module__s2amZW__button",
  "default": "button-module__s2amZW__default",
  "ghost": "button-module__s2amZW__ghost",
  "primary": "button-module__s2amZW__primary",
  "s": "button-module__s2amZW__s",
  "secondary": "button-module__s2amZW__secondary",
});
